import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface CreatorSidebarProps {
  onUploadClick?: () => void;
}

export default function CreatorSidebar({ onUploadClick }: CreatorSidebarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/creator/dashboard', icon: 'ri-home-5-line', label: '홈', type: 'link' },
    { path: '/creator/upload', icon: 'ri-upload-cloud-line', label: '콘텐츠 업로드', type: 'button' },
    { path: '/creator/contents', icon: 'ri-gallery-line', label: '내 콘텐츠', type: 'link' },
    { path: '/creator/subscribers', icon: 'ri-user-heart-line', label: '구독자 관리', type: 'link' },
    { path: '/creator/tips', icon: 'ri-gift-line', label: '팁 받기', type: 'link' },
    { path: '/creator/chat', icon: 'ri-chat-3-line', label: '채팅', type: 'link' },
  ];

  const handleMenuClick = (item: typeof menuItems[0]) => {
    if (item.type === 'button' && onUploadClick) {
      onUploadClick();
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* 모바일 햄버거 버튼 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl shadow-lg flex items-center justify-center cursor-pointer"
      >
        <i className={`${isOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
      </button>

      {/* 오버레이 */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
        ></div>
      )}

      {/* 사이드바 */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white/90 backdrop-blur-lg border-r border-pink-100 shadow-xl z-40 transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {/* 로고 */}
        <div className="p-6 border-b border-pink-100">
          <Link to="/creator/dashboard" className="cursor-pointer">
            <h1 className="text-3xl font-black bg-gradient-to-r from-pink-500 via-purple-500 to-blue-400 bg-clip-text text-transparent">
              MyFanHub
            </h1>
            <p className="text-xs text-gray-600 mt-1">크리에이터 대시보드</p>
          </Link>
        </div>

        {/* 메뉴 */}
        <nav className="p-4 space-y-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            
            if (item.type === 'button') {
              return (
                <button
                  key={item.path}
                  onClick={() => handleMenuClick(item)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all cursor-pointer ${
                    isActive
                      ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-pink-50'
                  }`}
                >
                  <i className={`${item.icon} text-xl`}></i>
                  <span className="font-medium text-sm">{item.label}</span>
                </button>
              );
            }
            
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all cursor-pointer ${
                  isActive
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-pink-50'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
                <span className="font-medium text-sm">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* 하단 프로필 */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-pink-100">
          <div className="flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-pink-50 to-purple-50 cursor-pointer hover:from-pink-100 hover:to-purple-100 transition-all">
            <div className="w-10 h-10 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center text-white font-bold">
              지
            </div>
            <div className="flex-1">
              <p className="font-semibold text-sm text-gray-800">지은</p>
              <p className="text-xs text-gray-600">크리에이터</p>
            </div>
            <i className="ri-logout-box-line text-gray-600 text-xl"></i>
          </div>
        </div>
      </div>
    </>
  );
}